import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import handleDataDependencies from './fetch-data';

export default function getProvider({ store, routes, DevTools }) {
  function fetchData(reload) {
    if (!__CLIENT__ || typeof window === 'undefined') {
      return Promise.resolve();
    }
  
    const location = window.location;
  
    return Promise.resolve(
      handleDataDependencies({
        location,
        store,
        renderProps: {},
        reload
      })
    ).then(() =>
      Promise.resolve(
        handleDataDependencies({
          location,
          store,
          renderProps: {},
          deferred: true,
          reload
        })
      )
    );
  }

  const router = <BrowserRouter>{routes}</BrowserRouter>;

  const component = (
    <Provider store={store}>
      {DevTools ? (
        <div>
          {router}
          <DevTools />
        </div>
      ) : (
        router
      )}
    </Provider>
  );

  const App = () => component;

  return { App, component, fetchData };
}